import React, { Component } from 'react'
import { Input } from '@driftt/tide-core-legacy'

import SimpleSelect from 'components/shared/SimpleSelect'
import { AddIcon, RemoveIcon, OrNode } from './IsAnyOfInputs'

const IS_IN_WATCHLIST = "has key:value"
const NOT_IS_IN_WATCHLIST = "does not have key:value"
const IS_WATCHLIST_VALUE_NULL = "has a null value"
const NOT_IS_WATCHLIST_VALUE_NULL = "does not have a null value"

const OPTIONS = [
  { value: 'isInWatchlist', text: IS_IN_WATCHLIST },
  { value: 'notIsInWatchlist', text: NOT_IS_IN_WATCHLIST },
  { value: 'isWatchlistValueNull', text: IS_WATCHLIST_VALUE_NULL },
  { value: 'notIsWatchlistValueNull', text: NOT_IS_WATCHLIST_VALUE_NULL }
]

class DemandbaseWatchlistInputs extends Component {
  static defaultProps = {
    optionTypes: ['isInWatchlist', 'notIsInWatchlist', 'isWatchlistValueNull', 'notIsWatchlistValueNull'],
  }

  onAddString() {
    const strings = this.props.conditionValue.get('value')
    this.props.conditionUpdater('value', strings.push(""))
  }

  makeOnRemove(index) {
    return () => {
      const strings = this.props.conditionValue.get('value')
      this.props.conditionUpdater('value', strings.splice(index, 1))
    }
  }

  makeStringInputChange(index, event) {
    const value = event.target ? event.target.value : event.value

    const strings = this.props.conditionValue.get('value')
    this.props.conditionUpdater('value', strings.set(index, value))
  }

  renderAddButton() {
    return (
      <AddIcon
        onClick={ this.onAddString.bind(this) }
      />
    )
  }

  renderRemoveIcon(index) {
    return (
      <RemoveIcon
        onClick={ this.makeOnRemove(index) }
      />
    )
  }

  renderStringInput(value, index, placeholder) {
    return (
      <Input
        onChange={(value) => this.makeStringInputChange(index, value)}
        value={value}
        placeholder={placeholder}
      />
    )
  }

  onOperatorSelect(operator) {
    this.props.conditionUpdater('operator', operator)
  }

  getSelectedValue() {
    const { conditionValue } = this.props
    return _.keyBy(OPTIONS, 'value')[conditionValue.get('operator')].text
  }

  render() {
    const { conditionValue, optionTypes } = this.props
    const strings = conditionValue.get('value')
    const selects = strings.map((stringToMatch, index, { size } ) => {
      let actionButton
      if (index === 0) {
        actionButton = this.renderAddButton()
      } else {
        actionButton = this.renderRemoveIcon(index)
      }
      const node = [
        this.renderStringInput(stringToMatch, index, conditionValue.get('placeholder')),
        actionButton
      ]
      if (index != size - 1) {
        node.push(OrNode)
      }
      return node
    })

    const options = _.filter(OPTIONS, ({ value }) => optionTypes.includes(value))

    return (
      <div className="flex-space-around flex-1 flex-wrap">
        <SimpleSelect
          onSelection={this.onOperatorSelect.bind(this)}
          options={options}
          selectedValue={this.getSelectedValue()}
        />
        { selects }
      </div>
    )
  }
}

export default DemandbaseWatchlistInputs



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/TargetConditionInput/TargetConditionEditModal/DemandbaseWatchlistInputs.js